export default __webpack_public_path__ + "static/media/Honored Boots of the Ancestors.9e8cd8a2.jpg";